import { AlertTriangle, DollarSign, Package } from "lucide-react";
import { REPORTS } from "@/constants/testIds";

/** Resumen de inventario + alertas de stock bajo, reutilizado en el
 * Dashboard ejecutivo (valores en vivo desde /api/inventory). */
export default function InventorySummaryCard({ summary, lowStockProducts }) {
  return (
    <div className="bg-white border border-border rounded-xl p-5" data-testid={REPORTS.inventorySummaryCard}>
      <h3 className="text-sm font-medium text-foreground mb-4">Inventario</h3>
      <div className="grid grid-cols-3 gap-3 mb-4">
        <div>
          <DollarSign className="w-4 h-4 text-brand mb-1" />
          <p className="font-serif text-xl text-foreground">${summary.total_inventory_value.toFixed(0)}</p>
          <p className="text-xs text-muted-foreground">Valor total</p>
        </div>
        <div>
          <Package className="w-4 h-4 text-brand mb-1" />
          <p className="font-serif text-xl text-foreground">{summary.total_products}</p>
          <p className="text-xs text-muted-foreground">Productos</p>
        </div>
        <div>
          <AlertTriangle className="w-4 h-4 text-[#A34B49] mb-1" />
          <p className="font-serif text-xl text-foreground">{summary.low_stock_count}</p>
          <p className="text-xs text-muted-foreground">Stock bajo</p>
        </div>
      </div>
      {lowStockProducts.length > 0 && (
        <div className="border-t border-border pt-3 space-y-1.5" data-testid={REPORTS.lowStockList}>
          {lowStockProducts.map((p) => (
            <div key={p.id} className="flex items-center justify-between text-xs">
              <span className="text-foreground">{p.name}</span>
              <span className="text-[#A34B49] font-medium">{p.stock_quantity} / {p.min_stock} {p.unit}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
